import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import axios from 'axios'
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import NumberFormatCustom from '../../../../NumberFormatCustom';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  row: {
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  controlLabel: {
    width: 200
  },
  formControl: {
    marginTop: theme.spacing(1)
  }
}));

const SlipsToolbar = props => {
  const classes = useStyles();
  const { className, financeuser, getMoneyTypeValue } = props;
  const [moneyTypeData, setMoneyTypeData] = useState([]);  // select data from database
  const [checklist, setChecklist] = useState([]);
  const [values, setValues] = useState([]);

  const [state, setState] = useState({});
  let source = axios.CancelToken.source();


  const loadMoneyType = async () => {
    const url = 'https://eslip.snru.ac.th/backend/api/moneytype';
    try {
      const result = await axios(url, {
        cancelToken: source.token
      });
      setMoneyTypeData(result.data.data);
      return result.data.data;
    } catch (error) {
      console.log(error)
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await loadMoneyType()
        await getFinanceUser(financeuser, data);
        return () => {
          source.cancel();
        };
      } catch (error) {
        console.log(error)
      }
    }
    fetchData();
  }, [financeuser]);

  const getFinanceUser = async (person, money) => {
    let obj1 = {};
    let obj2 = {};
    let obj3 = [];
    let obj4 = [];
    const url = 'https://eslip.snru.ac.th/backend/api/financeUser/' + person.person.citizen_id;
    try {
      const response = await axios.get(url, {
        cancelToken: source.token
      });
      response.data.data.map(element => {
        obj1 = { ...obj1, [element.money_type_id]: false }
        obj2 = { ...obj2, [element.money_type_id]: element.money_type_id }
      });

      setState({ ...state, ...obj1 });
      const result1 = Object.values(obj2);
      //setValues(result1);
      const data = filter(money, { money_type_id: result1 });
      setChecklist(data);

      // นำข้อมูลใส่บน header ตาราง
      obj3.push({
        title: 'เลขที่', field: 'position_num', editable: 'never',
        cellStyle: {
          fontSize: 12,
          minWidth: 120,
          color: '#3f51b5',
        },
        headerStyle: {
          fontSize: 12,
          textAlign: 'left',
          fontWeight: "bold"
        },
      }, {
        title: 'ชื่อ - สกุล', field: 'fullname', editable: 'never',
        cellStyle: {
          fontSize: 12,
          minWidth: 200,
          color: '#3f51b5',
        },
        headerStyle: {
          fontSize: 12,
          textAlign: 'left',
          fontWeight: "bold",
        },
      });
      obj4.push(
        {
          title: 'รวมรายการได้', field: 'sumincome', editable: 'never',
          cellStyle: {
            fontSize: 12,
            minWidth: 130,
            color: '#0fca8d',
            fontWeight: "bold",
            padding: '5px'
          },
          headerStyle: {
            fontSize: 12,
            textAlign: 'left',
            fontWeight: "bold",
            padding: '5px'
          },
        },
        {
          title: 'รวมรายการหัก', field: 'sumdeduct', editable: 'never',
          cellStyle: {
            fontSize: 12,
            minWidth: 130,
            color: '#8c0808',
            fontWeight: "bold",
            padding: '5px'
          },
          headerStyle: {
            fontSize: 12,
            textAlign: 'left',
            fontWeight: "bold",
            padding: '5px'
          },
        },
        {
          title: 'คงเหลือ', field: 'sumtotal2', editable: 'never',
          cellStyle: {
            fontSize: 12,
            minWidth: 130,
            color: '#8c0808',
            fontWeight: "bold",
            padding: '5px'
          },
          headerStyle: {
            fontSize: 12,
            textAlign: 'left',
            fontWeight: "bold",
            padding: '5px'
          },
        },
        {
          title: 'รวมเงินทั้งสิ้น', field: 'sumtotal', editable: 'never',
          cellStyle: {
            fontSize: 12,
            minWidth: 130,
            color: '#62a509',
            fontWeight: "bold",
            padding: '5px'
          },
          headerStyle: {
            fontSize: 12,
            textAlign: 'left',
            fontWeight: "bold",
            padding: '5px'
          },
        },
        {
          title: 'ธนาคาร',
          field: 'bank_name',
          cellStyle: {
            fontSize: 12,
            minWidth: 150,
            color: '#3f51b5',
          },
          headerStyle: {
            fontSize: 12,
            textAlign: 'left',
            fontWeight: "bold"
          },
          lookup: { 'กรุงไทย': 'กรุงไทย', 'กรุงศรี': 'กรุงศรี', 'เช็คธนาคารกรุงศรี':'เช็คธนาคารกรุงศรี', 'ทหารไทย': 'ทหารไทย' },
        },
        {
          title: 'เลขที่บัญชี', field: 'bank_account',
          cellStyle: {
            fontSize: 12,
            minWidth: 150,
            color: '#3f51b5',
          },
          headerStyle: {
            fontSize: 12,
            textAlign: 'left',
            fontWeight: "bold"
          },
        },
        {
          title: 'รหัสโครงการ', field: 'project_activities_id',
          cellStyle: {
            fontSize: 12,
            minWidth: 160,
            color: '#3f51b5',
          },
          headerStyle: {
            fontSize: 12,
            textAlign: 'left',
            fontWeight: "bold"
          },
        },
        {
          title: 'หมายเหตุ', field: 'etc',
          cellStyle: {
            fontSize: 12,
            minWidth: 150,
            color: '#3f51b5',
          },
          headerStyle: {
            fontSize: 12,
            textAlign: 'left',
            fontWeight: "bold"
          },
        });

      let headerTable = data.map(header => ({
        title: [header.money_type_name].toString(),
        field: [header.money_type_id].toString(),
        type: 'numeric',
        editComponent: ({ onChange, value }) => (
          <TextField
            value={value}
            onChange={e => onChange(e.target.value)}
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
            inputProps={{
              style: {
                textAlign: "right",
                fontSize: 12,
                color: '#F70D1A'
              }
            }}
          />
        ),
        cellStyle: {
          fontSize: 12,
          minWidth: 190,
          color: '#3f51b5',
        },
        headerStyle: {
          fontSize: 12,
          textAlign: 'right',
          fontWeight: "bold",
        }
      }));
     // obj3.push.apply(obj3, headerTable)
      obj3.push.apply(obj3, obj4)
      getMoneyTypeValue(obj3);
    } catch (error) {
      console.log(error)
    }
  }

  const handleChange = name => event => {

    setState({ ...state, [name]: event.target.checked });
    const index = values.indexOf(parseInt(event.target.value));
    (event.target.checked) ? (values.push(parseInt(event.target.value))) : (values.splice(index, 1))
    const data = filter(moneyTypeData, { money_type_id: values });

    let obj = [];
    let obj1 = [];
    obj.push({
      title: 'เลขที่', field: 'position_num', editable: 'never',
      cellStyle: {
        fontSize: 12,
        minWidth: 120,
        color: '#3f51b5',
      },
      headerStyle: {
        fontSize: 12,
        textAlign: 'left',
        fontWeight: "bold"
      },
    }, {
      title: 'ชื่อ - สกุล', field: 'fullname', editable: 'never',
      cellStyle: {
        fontSize: 12,
        minWidth: 200,
        color: '#3f51b5',
      },
      headerStyle: {
        fontSize: 12,
        textAlign: 'left',
        fontWeight: "bold"
      },
    });

    obj1.push(
      {
        title: 'รวมรายการได้', field: 'sumincome', editable: 'never',
        cellStyle: {
          fontSize: 12,
          minWidth: 130,
          color: '#0fca8d',
          fontWeight: "bold",
          padding: '5px'
        },
        headerStyle: {
          fontSize: 12,
          textAlign: 'left',
          fontWeight: "bold",
          padding: '5px'
        },
      },
      {
        title: 'รวมรายการหัก', field: 'sumdeduct', editable: 'never',
        cellStyle: {
          fontSize: 12,
          minWidth: 130,
          color: '#8c0808',
          fontWeight: "bold",
          padding: '5px'
        },
        headerStyle: {
          fontSize: 12,
          textAlign: 'left',
          fontWeight: "bold",
          padding: '5px'
        },
      },
      {
        title: 'คงเหลือ', field: 'sumtotal2', editable: 'never',
        cellStyle: {
          fontSize: 12,
          minWidth: 130,
          color: '#8c0808',
          fontWeight: "bold",
          padding: '5px'
        },
        headerStyle: {
          fontSize: 12,
          textAlign: 'left',
          fontWeight: "bold",
          padding: '5px'
        },
      },
      {
        title: 'รวมเงินทั้งสิ้น', field: 'sumtotal', editable: 'never',
        cellStyle: {
          fontSize: 12,
          minWidth: 130,
          color: '#62a509',
          fontWeight: "bold",
          padding: '5px'
        },
        headerStyle: {
          fontSize: 12,
          textAlign: 'left',
          fontWeight: "bold",
          padding: '5px'
        },
      },
      {
      title: 'ธนาคาร',
      field: 'bank_name',
      cellStyle: {
        fontSize: 12,
        minWidth: 150,
        color: '#3f51b5',
      },
      headerStyle: {
        fontSize: 12,
        textAlign: 'left',
        fontWeight: "bold"
      },
      lookup: { 'กรุงไทย': 'กรุงไทย', 'กรุงศรี': 'กรุงศรี','เช็คธนาคารกรุงศรี':'เช็คธนาคารกรุงศรี', 'ทหารไทย': 'ทหารไทย' },
    },
      {
        title: 'เลขที่บัญชี', field: 'bank_account',
        cellStyle: {
          fontSize: 12,
          minWidth: 150,
          color: '#3f51b5',
        },
        headerStyle: {
          fontSize: 12,
          textAlign: 'left',
          fontWeight: "bold"
        },
      },
      {
        title: 'รหัสโครงการ', field: 'project_activities_id',
        cellStyle: {
          fontSize: 12,
          minWidth: 160,
          color: '#3f51b5',
        },
        headerStyle: {
          fontSize: 12,
          textAlign: 'left',
          fontWeight: "bold"
        },
      },
      {
        title: 'หมายเหตุ', field: 'etc',
        cellStyle: {
          fontSize: 12,
          minWidth: 150,
          color: '#3f51b5',
        },
        headerStyle: {
          fontSize: 12,
          textAlign: 'left',
          fontWeight: "bold"
        },
      });

    let headerTable = data.map(header => ({
      title: [header.money_type_name].toString(),
      field: [header.money_type_id].toString(),
      type: 'numeric',
      editComponent: ({ onChange, value }) => (
        <TextField
          value={value}
          onChange={e => onChange(e.target.value)}
          InputProps={{
            inputComponent: NumberFormatCustom,
          }}
          inputProps={{
            style: {
              textAlign: "right",
              fontSize: 12,
              color: '#F70D1A',
              fontWeight: "bold"
            }
          }}
        />
      ),
      cellStyle: {
        fontSize: 12,
        minWidth: 180,
        color: '#3f51b5',
      },
      headerStyle: {
        fontSize: 12,
        textAlign: 'right',
        fontWeight: "bold"
      }
    }));
    obj.push.apply(obj, headerTable)
    obj.push.apply(obj, obj1)
    getMoneyTypeValue(obj);
  };

  const getValue = value => (typeof value === 'string' ? value.toUpperCase() : value);

  const filter = (array, filters) => {
    const filterKeys = Object.keys(filters);
    return array.filter(item => {
      // validates all filter criteria
      return filterKeys.every(key => {
        // ignores an empty filter
        if (!filters[key].length) return true;
        return filters[key].find(filter => getValue(filter) === getValue(item[key]));
      });
    });
  }

  const moneytypes1 = filter(checklist, { income_type_id: [1] });
  const moneytypes2 = filter(checklist, { income_type_id: [2] });

  return (
    <div className={classes.root}>
      <FormControl component="fieldset">
        <FormLabel component="legend"><h3>รายการได้</h3></FormLabel>
        <FormGroup aria-label="position" name="position" row>
          {
            moneytypes1.map((moneytype, i) =>
              <FormControlLabel key={i} className={classes.controlLabel}
                control={
                  <Checkbox
                    checked={state[moneytype.money_type_id] || false}
                    onChange={handleChange(moneytype.money_type_id)}
                    value={moneytype.money_type_id}
                    color="primary"
                  />
                }
                label={moneytype.money_type_name}
              />)
          }

        </FormGroup>
        <FormLabel component="legend" className={classes.formControl}><h3>รายการหัก</h3></FormLabel>
        <FormGroup aria-label="position" name="position" row>
          {
            moneytypes2.map((moneytype, i) =>
              <FormControlLabel key={i} className={classes.controlLabel}
                control={
                  <Checkbox
                    checked={state[moneytype.money_type_id] || false}
                    onChange={handleChange(moneytype.money_type_id)}
                    value={moneytype.money_type_id}
                    color="primary"
                  />
                }
                label={moneytype.money_type_name}
              />)
          }
        </FormGroup>
      </FormControl>
    </div>
  );
};

SlipsToolbar.propTypes = {
  className: PropTypes.string,
  MoneyTypeValue: PropTypes.array,
  financeuser: PropTypes.object,
  getMoneyTypeValue: PropTypes.func
};

export default SlipsToolbar;
